// import { html } from 'lit';
// import { _converse, api, log, Model } from '@converse/headless';
// import { __ } from 'i18n';
// import BaseModal from 'plugins/modal/modal.js';
// import { compressImage } from 'utils/file.js';
// import { modal_close_button } from 'plugins/modal/templates/buttons.js';

// // Импортируем ваши специфические шаблоны для Sonata
// import tplLogoutButton from '../templates/logout_button.js';
// import tplSonataProfileModal from '../templates/tplSonataProfileModal.js';
// import SonataLogoutModal from './SonataLogoutModal.js';

// import './styles/sonata-profile.scss';

// export default class SonataProfileModal extends BaseModal {
//     /**
//      * @typedef {import('@converse/headless/types/plugins/vcard/types').VCardData} VCardData
//      * @typedef {import("@converse/headless").Profile} Profile
//      * @typedef {import("lit").TemplateResult} TemplateResult
//      */

//     static properties = {
//         _submitting: { state: true },
//         _show_clear_button: { type: Boolean, state: true },
//         model: { type: Model },
//         tab: { type: String },
//     };

//     constructor(options) {
//         super(options);
//         this.tab = 'status'; // Вкладка по умолчанию
//         this._show_clear_button = false;
//     }

//     initialize() {
//         super.initialize();
//         this.listenTo(this.model, 'change', this.render);

//         // Фокус на поле статуса при открытии
//         this.addEventListener(
//             'shown.bs.modal',
//             () => {
//                 /** @type {HTMLInputElement} */
//                 (this.querySelector('input[name="status_message"]'))?.focus();
//             },
//             false,
//         );

//         api.trigger('sonataProfileModalInitialized', this.model);
//     }

//     willUpdate(changed) {
//         if (changed.has('model')) {
//             this._show_clear_button = !!this.model.get('status_message');
//         }
//     }

//     getModalTitle() {
//         // Кастомный заголовок для Sonata
//         return __('Мій Профіль');
//     }

//     renderModal() {
//         // Используем новый шаблон
//         return tplSonataProfileModal(this);
//     }

//     renderModalFooter() {
//         return api.settings.get('allow_logout')
//             ? html`<div class="modal-footer d-flex justify-content-between">
//                   ${modal_close_button} ${tplLogoutButton(this)}
//               </div>`
//             : '';
//     }

//     /**
//      * Сохранение VCard через API
//      * @param {VCardData} data
//      */
//     async setVCard(data) {
//         const bare_jid = _converse.session.get('bare_jid');
//         try {
//             await api.vcard.set(bare_jid, data);
//             return true;
//         } catch (err) {
//             log.fatal(err);
//             this.alert(__('Виникла помилка при збереженні профілю. Перевірте консоль розробника.'));
//             return false;
//         }
//     }

//     /**
//      * Обработка отправки формы профиля (Данные + Аватар)
//      * @param {SubmitEvent} ev
//      */
//     async onProfileFormSubmitted(ev) {
//         ev.preventDefault();
//         this._submitting = true;

//         const form_data = new FormData(/** @type {HTMLFormElement} */ (ev.target));
//         const image_file = /** @type {File} */ (form_data.get('avatar_image'));

//         const data = {
//             fn: form_data.get('fn'),
//             nickname: form_data.get('nickname'),
//             role: form_data.get('role'),
//             email: form_data.get('email'),
//             url: form_data.get('url'),
//         };

//         if (image_file?.size) {
//             const image_data = await compressImage(image_file);
//             const reader = new FileReader();
//             reader.onloadend = async () => {
//                 Object.assign(data, {
//                     image: btoa(/** @type {string} */ (reader.result)),
//                     image_type: image_file.type,
//                 });
//                 if (await this.setVCard(data)) {
//                     this._submitting = false;
//                     // this.modal.hide();
//                     api.toast.show('vcard-updated', { type: 'success', body: __('Профіль Sonata оновлено') });
//                 }
//             };
//             reader.readAsBinaryString(image_data);
//         } else {
//             Object.assign(data, {
//                 image: this.model.vcard.get('image'),
//                 image_type: this.model.vcard.get('image_type'),
//             });
//             if (await this.setVCard(data)) {
//                 // this.modal.hide();
//                 api.toast.show('vcard-updated', { type: 'success', body: __('Профіль Sonata оновлено') });
//             }
//             this._submitting = false;
//         }
//     }

//     onStatusFormSubmitted(ev) {
//         ev.preventDefault();
//         const data = new FormData(/** @type {HTMLFormElement} */ (ev.target));
//         let show, presence;
//         const chat_status = data.get('chat_status');

//         if (chat_status === 'online') {
//             presence = 'online';
//         } else {
//             show = chat_status;
//         }

//         this.model.save({
//             status_message: data.get('status_message'),
//             presence,
//             show,
//         });
//         this.alert(__('Статус оновлено'), 'info');
//     }

//     clearStatusMessage(ev) {
//         ev?.preventDefault();
//         this._show_clear_button = false;
//         const input = /** @type {HTMLInputElement} */ (this.querySelector('input[name="status_message"]'));
//         if (input) input.value = '';
//     }

//     async logOut(ev) {
//         ev?.preventDefault();

//         // 1. Закрываем текущий модал профиля
//         this.close();

//         // 2. Вместо api.confirm вызываем наш кастомный модал через API
//         api.modal.show('sonata-logout-modal');
//     }

//     // async logOut(ev) {
//     //     ev?.preventDefault();
//     //     this.close();
//     //     const result = await api.confirm(__('Бажаєте покинути застосунок?'));
//     //     if (result) {
//     //         api.user.logout();
//     //     }
//     // }
// }

// api.elements.define('sonata-profile-modal', SonataProfileModal);
import { html } from 'lit';
import { _converse, api, log, Model } from '@converse/headless';
import { __ } from 'i18n';
import BaseModal from 'plugins/modal/modal.js';
import { compressImage } from 'utils/file.js';
import { modal_close_button } from 'plugins/modal/templates/buttons.js';

import tplLogoutButton from '../templates/logout_button.js';
import tplSonataProfileModal from '../templates/tplSonataProfileModal.js';
import SonataLogoutModal from './SonataLogoutModal.js';

import './styles/sonata-profile.scss';

export default class SonataProfileModal extends BaseModal {
    /**
     * @typedef {import('@converse/headless/types/plugins/vcard/types').VCardData} VCardData
     * @typedef {import("@converse/headless").Profile} Profile
     * @typedef {import("lit").TemplateResult} TemplateResult
     */

    static properties = {
        _submitting: { state: true },
        _show_clear_button: { type: Boolean, state: true },
        model: { type: Model },
        tab: { type: String },

        // Нові реактивні властивості для форми зміни пароля
        oldPassword: { type: String, state: true },
        newPassword: { type: String, state: true },
        confirmPassword: { type: String, state: true },
        isPasswordFormValid: { type: Boolean, state: true },
        validation: { type: Object, state: true },
    };

    constructor(options) {
        super(options);
        this.tab = 'profile'; // Вкладка за замовчуванням (згідно з шаблоном HTML)
        this._show_clear_button = false;
        this._update_percent = null;

        // Ініціалізація стану валідації пароля
        this.oldPassword = '';
        this.newPassword = '';
        this.confirmPassword = '';
        this.isPasswordFormValid = false;
        this.validation = {
            oldPasswordCorrect: true, // Перемикаємо в false, якщо бекенд поверне помилку старого пароля
            lengthValid: false,
            hasLowercase: false,
            hasUppercase: false,
            hasNumber: false,
            passwordsMatch: false,
        };
    }

    initialize() {
        super.initialize();
        this.listenTo(this.model, 'change', this.render);

        this.addEventListener(
            'shown.bs.modal',
            () => {
                /** @type {HTMLInputElement} */
                (this.querySelector('input[name="status_message"]'))?.focus();
            },
            false,
        );

        window.electronApp?.onUpdateProgress((percent) => {
            this._update_percent = percent;
            this.requestUpdate();
        });

        api.trigger('sonataProfileModalInitialized', this.model);
    }

    willUpdate(changed) {
        if (changed.has('model')) {
            this._show_clear_button = !!this.model.get('status_message');
        }
    }

    getModalTitle() {
        return __('Мій Профіль');
    }

    renderModal() {
        return tplSonataProfileModal(this);
    }

    renderModalFooter() {
        return api.settings.get('allow_logout')
            ? html`<div class="modal-footer d-flex justify-content-between">${modal_close_button} ${tplLogoutButton(this)}</div>`
            : '';
    }

    /**
     * Динамічна валідація пароля на клієнті (викликається на @input)
     */
    validatePasswordForm() {
        const p = this.newPassword || '';
        const cp = this.confirmPassword || '';

        // Перевірка вимог регулярними виразами
        this.validation = {
            ...this.validation,
            lengthValid: p.length >= 8,
            hasLowercase: /[a-zа-яєіїґ]/.test(p),
            hasUppercase: /[A-ZА-ЯЄІЇҐ]/.test(p),
            hasNumber: /[0-9]/.test(p),
            passwordsMatch: p === cp && p.length > 0,
        };

        // Кнопка стає активною лише коли виконані всі 5 умов нового пароля + введено поточний
        this.isPasswordFormValid =
            this.oldPassword.length > 0 &&
            this.validation.lengthValid &&
            this.validation.hasLowercase &&
            this.validation.hasUppercase &&
            this.validation.hasNumber &&
            this.validation.passwordsMatch;

        this.requestUpdate();
    }

    /**
     * Сабміт форми зміни пароля та обробка помилок бекенду
     */
    async onPasswordFormSubmitted(ev) {
        ev.preventDefault();
        this._submitting = true;

        // Витягуємо токен авторизації з Converse сесії
        const token = _converse.session?.get('access_token') || api.settings.get('token');

        // Вирішення помилки 422 (The field must be an integer / "number"):
        // Зазвичай це внутрішній абонентський ID (subscriber ID) або номер телефону без '+'.
        // Беремо його з вашої моделі (так само, як ви виводите в шаблоні company чи login)
        const userNumberRaw =
            this.model.get('company') || this.model.get('username') || _converse.session.get('username');
        const userNumber = parseInt(userNumberRaw, 10) || 0;

        const payload = {
            oldPassword: this.oldPassword,
            password: this.newPassword,
            password_confirmation: this.confirmPassword,
            number: userNumber, // Додаємо обов'язкове для вашого API поле
        };

        try {
            const response = await fetch('/api/subscriber/change-password', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify(payload),
            });

            if (response.status === 200) {
                api.toast.show('password-changed', { type: 'success', body: __('Пароль успішно змінено') });

                // Очищаємо поля форми
                this.oldPassword = '';
                this.newPassword = '';
                this.confirmPassword = '';
                this.validation.oldPasswordCorrect = true;

                // Перемикаємо вкладку назад на профіль
                this.tab = 'profile';
                this.requestUpdate();
            } else if (response.status === 422) {
                const errorData = await response.json();

                // Якщо бекенд каже, що confirmation не збігається або пароль слабкий
                if (errorData.errors?.password) {
                    this.validation.passwordsMatch = false;
                }
                // Якщо помилка в полі number (бек все одно незадоволений типом даних)
                if (errorData.errors?.number) {
                    api.toast.show('password-error', {
                        type: 'danger',
                        body: __('Помилка API: Некоректний ID користувача'),
                    });
                }

                this.requestUpdate();
            } else if (response.status === 403) {
                // Старий пароль не підійшов або OTP застарів
                this.validation.oldPasswordCorrect = false;
                this.requestUpdate();
                api.toast.show('password-error', {
                    type: 'danger',
                    body: __('Поточний пароль невірний або виникла помилка безпеки'),
                });
            } else {
                throw new Error(`Server returned ${response.status}`);
            }
        } catch (err) {
            log.fatal(err);
            api.toast.show('password-error', {
                type: 'danger',
                body: __('Не вдалося змінити пароль. Спробуйте пізніше.'),
            });
        } finally {
            this._submitting = false;
        }
    }

    /**
     * Сохранение VCard через API
     * @param {VCardData} data
     */
    async setVCard(data) {
        const bare_jid = _converse.session.get('bare_jid');
        try {
            await api.vcard.set(bare_jid, data);
            return true;
        } catch (err) {
            log.fatal(err);
            this.alert(__('Виникла помилка при збереженні профілю. Перевірте консоль розробника.'));
            return false;
        }
    }

    /**
     * Обработка отправки формы профиля (Данные + Аватар)
     */
    async onProfileFormSubmitted(ev) {
        ev.preventDefault();
        this._submitting = true;

        const form_data = new FormData(/** @type {HTMLFormElement} */ (ev.target));
        const image_file = /** @type {File} */ (form_data.get('avatar_image'));

        const data = {
            fn: form_data.get('fn'),
            nickname: form_data.get('nickname'),
            role: form_data.get('role'),
            email: form_data.get('email'),
            url: form_data.get('url'),
        };

        if (image_file?.size) {
            const image_data = await compressImage(image_file);
            const reader = new FileReader();
            reader.onloadend = async () => {
                Object.assign(data, {
                    image: btoa(/** @type {string} */ (reader.result)),
                    image_type: image_file.type,
                });
                if (await this.setVCard(data)) {
                    this._submitting = false;
                    api.toast.show('vcard-updated', { type: 'success', body: __('Профіль Sonata оновлено') });
                }
            };
            reader.readAsBinaryString(image_data);
        } else {
            Object.assign(data, {
                image: this.model.vcard.get('image'),
                image_type: this.model.vcard.get('image_type'),
            });
            if (await this.setVCard(data)) {
                api.toast.show('vcard-updated', { type: 'success', body: __('Профіль Sonata оновлено') });
            }
            this._submitting = false;
        }
    }

    onStatusFormSubmitted(ev) {
        ev.preventDefault();
        const data = new FormData(/** @type {HTMLFormElement} */ (ev.target));
        let show, presence;
        const chat_status = data.get('chat_status');

        if (chat_status === 'online') {
            presence = 'online';
        } else {
            show = chat_status;
        }

        this.model.save({
            status_message: data.get('status_message'),
            presence,
            show,
        });
        this.alert(__('Статус оновлено'), 'info');
    }

    clearStatusMessage(ev) {
        ev?.preventDefault();
        this._show_clear_button = false;
        const input = /** @type {HTMLInputElement} */ (this.querySelector('input[name="status_message"]'));
        if (input) input.value = '';
    }

    async logOut(ev) {
        ev?.preventDefault();
        this.close();
        api.modal.show('sonata-logout-modal');
    }

    async checkForUpdates(ev) {
        ev?.preventDefault();
        if (!window.electronApp?.checkForUpdates) return;
        const result = await window.electronApp.checkForUpdates();
        if (result.status === 'available') {
            this._update_percent = 0;
            this.requestUpdate();
            this.alert(__('Знайдено оновлення %1$s. Завантажується...', result.version), 'info');
        } else if (result.status === 'not-available') {
            this.alert(__('У вас остання версія.'), 'info');
        } else {
            this.alert(__('Не вдалося перевірити оновлення. Спробуйте пізніше.'));
        }
    }
}

api.elements.define('sonata-profile-modal', SonataProfileModal);
